import Rails from '@rails/ujs'
import { createConsumer } from '@rails/actioncable'
import installCableProtocolGuard from './cableProtocolGuard'
import { DEFAULT_ERROR_MESSAGE } from './constants'

window.Rails = Rails
Rails.start()

installCableProtocolGuard()

const App = { cable: createConsumer() }
export { App }

export function collectErrors(hsh) {
  let text
  try {
    const errors = Object.keys(hsh).reduce((memo, key) => {
      memo.push(`${key}: ${hsh[key].join(', ')}`)
      return memo
    }, [])
    text = errors.join('\n')
  } catch (err) { // eslint-disable-line no-unused-vars
    text = DEFAULT_ERROR_MESSAGE
  }

  return text
}
